import { useTranslation } from 'react-i18next'

interface PaymentAmountProps {
  amount: number
  netAmount?: number
  taxAmount?: number
  currency?: 'CLP' | 'USD'
}

export default function PaymentAmount({
  amount,
  netAmount,
  taxAmount,
  currency = 'CLP',
}: PaymentAmountProps) {
  const { t } = useTranslation()
  const formatNumber = (value: number) =>
    new Intl.NumberFormat('es-CL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value)

  const currencySymbol = currency === 'CLP' ? '$' : 'US$'
  const hasBreakdown = netAmount !== undefined && taxAmount !== undefined

  return (
    <div className="text-center py-4">
      {hasBreakdown && (
        <div className="mb-4 space-y-1">
          <div className="flex justify-between items-center text-sm text-neutral-600 max-w-[200px] mx-auto">
            <span className="font-light">{t('payment.netAmount')}</span>
            <span className="font-light">{currencySymbol}{formatNumber(netAmount)}</span>
          </div>
          <div className="flex justify-between items-center text-sm text-neutral-600 max-w-[200px] mx-auto">
            <span className="font-light">{t('payment.tax')}</span>
            <span className="font-light">{currencySymbol}{formatNumber(taxAmount)}</span>
          </div>
          <div className="border-t border-neutral-200 max-w-[200px] mx-auto my-2" />
        </div>
      )}

      <p className="text-[11px] text-neutral-400 uppercase tracking-[0.2em] mb-3 font-medium">
        {t('payment.total')}
      </p>

      <div className="relative inline-flex items-baseline gap-2">
        <p className="font-serif font-medium tracking-tight leading-none
                      text-[48px] md:text-[56px] lg:text-[64px]
                      text-[#2D5016]
                      animate-amount">
          <span className="text-[0.5em] align-super font-light mr-1 opacity-70">
            {currencySymbol}
          </span>
          {formatNumber(amount)}
        </p>
        <span className="text-sm text-neutral-400 uppercase tracking-wider font-light self-center">
          {currency}
        </span>

        <div className="absolute -bottom-4 left-0 right-8 h-0.5
                        bg-gradient-to-r from-transparent via-[--color-copper] to-transparent
                        opacity-60" />
      </div>
    </div>
  )
}
